import apolloClient from "../graphql/utitl.js";
import gql from "graphql-tag";

// 查询优惠券活动
export function queryCouponActivityInfo(paramms) {
	return apolloClient.query({
		fetchPolicy: "no-cache",
		query: gql`query queryAllCouponActivity(
        $activityId: String
        $activityName: String
        $minBeginTime: String
        $maxBeginTime: String
        $minEndTime: String
        $maxEndTime: String
        $state: Int
        $partnerId: String
        $couponName: String
        $page: Int
        $size: Int
        $sort: [String]
    ){
        queryAllCouponActivity(
            couponActivityDTO: {
                activityId: $activityId     # 活动id
                activityName: $activityName # 活动名称
                minBeginTime: $minBeginTime # 最小开始时间
                maxBeginTime: $maxBeginTime # 最大开始时间
                minEndTime: $minEndTime     # 最小结束时间
                maxEndTime: $maxEndTime     # 最大结束时间
                state: $state               # 状态
                partnerId: $partnerId       # 商户id
                couponName: $couponName     # 优惠券名称
                page: $page                 # 当前页
                size: $size                 # 数据条目
                sort: $sort                 # 排序方式
            }
        ) {
            id
            activityId
            activityName
            activityDescribe
            beginTime
            endTime
            state
            partnerId
            posIdListStr
            availableProductType
            couponName
            couponValidDay
            maxIssuanceNum
            currentIssuedNum
            userMaxReceiveNum
            userDailyMaxReceiveNum
            createTime
            modifyTime
            modifyUserAccount
        }
    }`, variables: paramms
	})
}

//创建优惠券活动
export function createCouponActivity(params) {
  return apolloClient.mutate({
    fetchPolicy: "no-cache",
    mutation: gql`mutation createCouponActivity(
        $activityName: String!       #(必填) 活动名称
        $activityDescribe: String    #活动描述
        $beginTime: String!          #(必填) 开始时间
        $endTime: String!            #(必填) 结束时间
        $state: Int                  #状态 (1.正常；-1.停用)
        $partnerId: String!          #所属商户ID
        $posIdListStr: String        #可用网点列表 (多个以逗号隔开)
        $availableProductType: Int   #可用产品类型 (只支持单个)
        $couponName: String          #发放的优惠券名称
        $couponValidDay: Int         #发放的优惠券可用天数
        $maxIssuanceNum: Int         #最大发放数量
        $perIssuanceNum: Int         #每次扫码发放数量
        $currentIssuedNum: Int       #目前已发放数量
        $userMaxReceiveNum: Int      #用户最大领取数量
        $userDailyMaxReceiveNum: Int #用户每天最大领取数量
        $createTime: String          #创建时间
        $modifyTime: String          #修改时间
        $modifyUserAccount: String   #最后修改活动的用户
    ){
        createCouponActivity(
            couponActivityInput: {
                activityName: $activityName                     #(必填) 活动名称
                activityDescribe: $activityDescribe             #活动描述
                beginTime: $beginTime                           #(必填) 开始时间
                endTime: $endTime                               #(必填) 结束时间
                state: $state                                   #状态 (1.正常；-1.停用)
                partnerId: $partnerId                           #所属商户ID
                posIdListStr: $posIdListStr                     #可用网点列表 (多个以逗号隔开)
                availableProductType: $availableProductType     #可用产品类型 (只支持单个)
                couponName: $couponName                         #发放的优惠券名称
                couponValidDay: $couponValidDay                 #发放的优惠券可用天数
                maxIssuanceNum: $maxIssuanceNum                 #最大发放数量
                perIssuanceNum: $perIssuanceNum                 #每次扫码发放数量
                currentIssuedNum: $currentIssuedNum             #目前已发放数量
                userMaxReceiveNum: $userMaxReceiveNum           #用户最大领取数量
                userDailyMaxReceiveNum: $userDailyMaxReceiveNum #用户每天最大领取数量
                createTime: $createTime                         #创建时间
                modifyTime: $modifyTime                         #修改时间
                modifyUserAccount: $modifyUserAccount           #最后修改活动的用户
            }
        )
        {
            code
            note
            couponActivity {
                id
                activityId
                activityName
                activityDescribe
                beginTime
                endTime
                state
                partnerId
                posIdListStr
                availableProductType
                couponName
                couponValidDay
                maxIssuanceNum
                perIssuanceNum
                currentIssuedNum
                userMaxReceiveNum
                userDailyMaxReceiveNum
                createTime
                modifyTime
                modifyUserAccount
            }
        }
    }`,
    variables: params
  })
}

//更新优惠券活动
export function updateCouponActivity(params) {
  return apolloClient.mutate({
    fetchPolicy: "no-cache",
    mutation: gql`mutation updateCouponActivity(
        $id: Int
        $activityName: String
        $activityDescribe: String
        $beginTime: String
        $endTime: String
        $state: Int
        $partnerId: String
        $posIdListStr: String
        $availableProductType: Int
        $couponName: String
        $couponValidDay: Int
        $maxIssuanceNum: Int
        $perIssuanceNum: Int
        $currentIssuedNum: Int
        $userMaxReceiveNum: Int
        $userDailyMaxReceiveNum: Int
        $createTime: String
        $modifyTime: String
        $modifyUserAccount: String
    ) {
        updateCouponActivity (
            couponActivityInput: {
                id: $id
                activityName: $activityName
                activityDescribe: $activityDescribe
                beginTime: $beginTime
                endTime: $endTime
                state: $state
                partnerId: $partnerId
                posIdListStr: $posIdListStr
                availableProductType: $availableProductType
                couponName: $couponName
                couponValidDay: $couponValidDay
                maxIssuanceNum: $maxIssuanceNum
                perIssuanceNum: $perIssuanceNum
                currentIssuedNum: $currentIssuedNum
                userMaxReceiveNum: $userMaxReceiveNum
                userDailyMaxReceiveNum: $userDailyMaxReceiveNum
                createTime: $createTime
                modifyTime: $modifyTime
                modifyUserAccount: $modifyUserAccount
            }
        ){
          code
          note
          couponActivity {
            id
            activityId
            activityName
            activityDescribe
            beginTime
            endTime
            state
            partnerId
            posIdListStr
            availableProductType
            couponName
            couponValidDay
            maxIssuanceNum
            perIssuanceNum
            currentIssuedNum
            userMaxReceiveNum
            userDailyMaxReceiveNum
            createTime
            modifyTime
            modifyUserAccount
          }
        }
    }`,
    variables: params
  })
}

// 查询优惠券列表
export function queryCoupon(params) {
  return apolloClient.query({
    fetchPolicy: "no-cache",
    query: gql`query queryCoupon(
        $couponId: String,                    #(可选) 优惠券编号
        $couponName: String,                #(可选) 优惠券名称（模糊搜索）
        $minReceiveTime: String,   #(可选) 最小_获取优惠券时间
        $maxReceiveTime: String,   #(可选) 最大_获取优惠券时间
        $minEffectiveTime: String, #(可选) 最小_生效时间
        $maxEffectiveTime: String, #(可选) 最大_生效时间
        $minFailureTime: String,   #(可选) 最小_失效时间
        $maxFailureTime: String,   #(可选) 最大_失效时间
        $availablePodId: String,              #(可选) 可用网点（模糊搜索）
        $availableProductType: Int,                 #(可选) 可用产品类型
        $state: Int,                                #(可选) 状态（1.正常；2.已使用；-1.作废）
        $activityId: String,                #(可选) 活动编号
        $userAccount: String,               #(可选) 用户账号
        $posId: String,                     #(可选) 优惠券在哪个网点用掉了，该网点的ID
        $orderId: String,                   #(可选) 优惠券抵扣的订单ID
        $page: Int,
        $size: Int,
        $sort:[String]
    ) {
      queryAllCoupon(
            # 查全部用CouponDTO:{}即可，要雇员权限，否则只能查自己用户号下的优惠券
            couponDTO: {
                couponId: $couponId,                    #(可选) 优惠券编号
                couponName: $couponName,                #(可选) 优惠券名称（模糊搜索）
                minReceiveTime: $minReceiveTime,   #(可选) 最小_获取优惠券时间
                maxReceiveTime: $maxReceiveTime,   #(可选) 最大_获取优惠券时间
                minEffectiveTime: $minEffectiveTime, #(可选) 最小_生效时间
                maxEffectiveTime: $maxEffectiveTime, #(可选) 最大_生效时间
                minFailureTime: $minFailureTime,   #(可选) 最小_失效时间
                maxFailureTime: $maxFailureTime,   #(可选) 最大_失效时间
                availablePodId: $availablePodId,              #(可选) 可用网点（模糊搜索）
                availableProductType: $availableProductType,                 #(可选) 可用产品类型
                state: $state,                                #(可选) 状态（1.正常；2.已使用；-1.作废）
                activityId: $activityId,                #(可选) 活动编号
                userAccount: $userAccount,               #(可选) 用户账号
                posId: $posId,                     #(可选) 优惠券在哪个网点用掉了，该网点的ID
                orderId: $orderId,                   #(可选) 优惠券抵扣的订单ID
                page: $page,
                size: $size,
                sort: $sort     #(可选) 默认根据获取时间倒序
            }
        ) {
            id
            couponId     # 优惠券编号
            couponName   # 优惠券名称
            receiveTime  # 获取时间
            effectiveTime# 生效时间
            failureTime  # 失效时间
            availablePosId  # 可用网点 （多个以逗号隔开，null代表全部）
            availableProductType  # 可用产品类型 （null代表全部）
            state        # 状态（1.正常；2.已使用；-1.作废）
            activityId   # 活动编号 (优惠券是从哪个活动领到的)
            userAccount  # 所属用户账号
            posId        # 网点ID (优惠券在哪个网点用掉了)
            useTime      # 使用时间
            orderId      # 订单ID
            deductionAmount # 优惠券抵扣金额
        }
    }`,
    variables: params
  })
}



// WEBPACK FOOTER //
// ./src/api/coupon.js